(function () {
  if (window.__pdpDifficultyPopupReady) return;
  window.__pdpDifficultyPopupReady = true;

  function closeAll(except) {
    document.querySelectorAll('[data-pdp-diff-popup]').forEach(function (popup) {
      if (except && popup === except) return;
      popup.hidden = true;
    });

    document.querySelectorAll('[data-pdp-diff-toggle]').forEach(function (button) {
      var popupId = button.getAttribute('aria-controls');
      if (except && popupId === except.id) return;
      button.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-pdp-diff-toggle]');

    if (toggle) {
      var popup = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!popup) return;

      var shouldOpen = popup.hidden;
      closeAll(popup);
      popup.hidden = !shouldOpen;
      toggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      return;
    }

    if (!event.target.closest('[data-pdp-diff]')) {
      closeAll();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });
})();
